export const APP_NAME = 'bd-portal-view'



// WEBPACK FOOTER //
// ./src/config/base.config.js